<template>
  <div class="login-container">
    <div class="login-card">
      <img src="@/assets/device-tracker-label-icon-v2.png" alt="Device Tracker" class="logo"/>
      <h1>Device Tracker</h1>
      <p>Sign in to view and manage test devices</p>
      <LoginButton @login-success="handleLogin"/>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import LoginButton from './LoginButton.vue'
import { COLORS, FONTS } from '@/styles/brand'

const router = useRouter()
const route = useRoute()

const handleLogin = () => {
  router.push(route.query.redirect || '/')
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(20, 64, 154, 0.8) 50%, rgba(31, 31, 79, 0.9) 100%),
    url('@/assets/nordeus-3840x1080-pattern_new.jpg') no-repeat center center fixed;
  background-size: cover;
  font-family: v-bind('FONTS.GOOGLE');
}

.login-card {
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 48px;
  border-radius: 24px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  height: 80px;
  margin-bottom: 24px;
}

h1 {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-size: 2rem;
  margin: 0 0 12px 0;
}

p {
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 32px 0;
  font-size: 1.1rem;
}
</style>
